const ProfileTabSkeleton = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 animate-pulse">
      {/* LEFT MAIN CARD */}
      <div className="lg:col-span-2 bg-white rounded-xl shadow-sm p-4 sm:p-6 space-y-6">
        {/* AVATAR + NAME */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between border-b border-border pb-6">
          {/* Avatar + Name */}
          <div className="flex items-center gap-4 sm:gap-5">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gray-200 rounded-full"></div>

            <div className="space-y-2 w-40 sm:w-52">
              <div className="h-5 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-full"></div>
            </div>
          </div>

          {/* Edit Button Area */}
          <div className="flex items-center gap-3 mt-4 sm:mt-0">
            <div className="h-8 bg-gray-200 rounded w-20"></div>
            <div className="h-8 bg-gray-200 rounded w-20"></div>
          </div>
        </div>

        {/* PERSONAL INFO TITLE */}
        <div className="h-6 bg-gray-200 rounded w-36"></div>

        {/* 3 Inputs */}
        <div className="space-y-4">
          {/* Full Name */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-20"></div>
            <div className="h-11 bg-gray-200 rounded"></div>
          </div>

          {/* Email + Phone */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[1, 2].map((i) => (
              <div key={i} className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-24"></div>
                <div className="h-11 bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>

          {/* Preferred City */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-28"></div>
            <div className="h-11 bg-gray-200 rounded"></div>
          </div>
        </div>

        {/* AGENT BUILDER SECTION (conditionally shown in real UI, but skeleton includes it gracefully) */}
        <div className="pt-4 border-t border-border space-y-5">
          {/* RERA ID */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-20"></div>
            <div className="h-11 bg-gray-200 rounded"></div>
          </div>

          {/* Operating Since */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-24"></div>
            <div className="h-11 bg-gray-200 rounded"></div>
          </div>

          {/* Operating Areas */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-32"></div>
            <div className="h-20 bg-gray-200 rounded"></div>
          </div>

          {/* Deal Types */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-24"></div>
            <div className="h-20 bg-gray-200 rounded"></div>
          </div>

          {/* Stats 3 box */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="space-y-2">
                <div className="h-4 bg-gray-200 rounded w-32"></div>
                <div className="h-11 bg-gray-200 rounded"></div>
              </div>
            ))}
          </div>

          {/* Work Status Toggle */}
          <div className="h-16 bg-gray-200 rounded"></div>

          {/* Company dropdown */}
          <div className="space-y-3">
            <div className="h-4 bg-gray-200 rounded w-28"></div>
            <div className="h-11 bg-gray-200 rounded"></div>
          </div>

          {/* Company preview card */}
          <div className="h-20 bg-gray-200 rounded"></div>

          {/* Create / Edit buttons */}
          <div className="h-6 bg-gray-200 rounded w-36"></div>
          <div className="h-6 bg-gray-200 rounded w-32"></div>
        </div>
      </div>

      {/* RIGHT SUMMARY CARD */}
      <div className="space-y-4">
        <div className="bg-white rounded-xl shadow-sm p-5 space-y-4">
          <div className="h-6 bg-gray-200 rounded w-40"></div>

          {/* rows */}
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="flex items-center justify-between">
              <div className="h-4 bg-gray-200 rounded w-28"></div>
              <div className="h-4 bg-gray-200 rounded w-20"></div>
            </div>
          ))}
        </div>

        <div className="bg-primary/80 rounded-xl p-5 space-y-3">
          <div className="h-6 bg-white/40 rounded w-10"></div>
          <div className="h-5 bg-white/40 rounded w-40"></div>
          <div className="h-4 bg-white/40 rounded w-52"></div>
          <div className="h-9 bg-white rounded w-full"></div>
        </div>
      </div>
    </div>
  );
};

export default ProfileTabSkeleton